// extracted by mini-css-extract-plugin
export default {"table":"Details_table__+4w1I"};